import { BaseModalProps } from '@copilot/common/components/modals/wrappers/base';
import { NameValidator } from './campaignCreationForm';
import { CampaignType } from '@copilot/data/responses/interface';

export type CampaignCreationProps = BaseModalProps & {
    /** Validates the name in the name editor (effectively just dupes check) */
    nameEditorValidator: NameValidator;
    /** The type of campaign to create */
    campaignType: CampaignType;
    /** Unused if isNewCampaignCreationEndpointEnabled feature flag is enabled */
    onCreate?: (name: string) => Promise<void>;
};

export type CampaignDuplicationProps = BaseModalProps & {
    /** Validates the name in the name editor (effectively just dupes check) */
    nameEditorValidator: NameValidator;
    /** The default name specified in name input */
    defaultName: string;
    /** The ID of the campaign to duplicate */
    campaignId: string;
};

/** Union type for the props that can be passed to the CampaignCreationModal component */
export type CampaignCreationModalProps = CampaignCreationProps | CampaignDuplicationProps;

/** Type guard to check if the props are for campaign duplication */
export function isDuplicationProps(
    props: CampaignCreationModalProps
): props is CampaignDuplicationProps {
    return 'campaignId' in props && 'defaultName' in props;
}
